'use client';

import { PrismicLink } from '@prismicio/react';
import { BlogPageDocument } from 'prismicio-types';
import React, { useEffect, useState } from 'react';
import { linkResolver } from 'src/prismicio';

const BlogRecentPostsList = () => {
    const [articles, setArticles] = useState<BlogPageDocument[]>();

    useEffect(() => {
        fetch('/prismic/api/get-recent-blog-posts')
            .then((response) => response.json())
            .then((result) => setArticles(result));
    }, []);

    return (
        <section className="bg-green-light px-4 py-8">
            <div className="m-auto max-w-[50rem]">
                <h2>Recent articles</h2>
                <div className="flex flex-col">
                    {articles?.map((item) => (
                        <PrismicLink
                            key={item.uid}
                            document={item}
                            linkResolver={linkResolver}
                            className="mt-4"
                        >
                            {item.data.title}
                        </PrismicLink>
                    ))}
                </div>
            </div>
        </section>
    );
};
export default BlogRecentPostsList;
